import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { PLANS_QUERY_KEYS } from "../queryKeys";
import { getTransactions } from "../services/paymentTransactions";

export const useGetTransactions = (limit: number, offset: number) => {
  const { i18n } = useTranslation();

  return useQuery({
    queryKey: [...PLANS_QUERY_KEYS.TRANSACTIONS, limit, offset, i18n.language],
    queryFn: () => getTransactions(limit, offset),
  });
};
